import React, { PureComponent } from 'react';
import { Carousel } from 'react-responsive-carousel';

import { Headline } from './headline';

export default class MobileHeadlinesSlider extends PureComponent {
  render() {
    const headlines = this.renderHeadlines();

    return this.props.headlines && this.props.headlines.length ? (
      <Carousel
        className="headlines-slider"
        showArrows={false}
        showThumbs={false}
        emulateTouch={false}
        showIndicators={true}
        autoPlay={false}
        showStatus={false}
        infiniteLoop={true}
        axis="horizontal"
        stopOnHover={false}
        transitionTime={1000}
        interval={20000}
      >
        {headlines}
      </Carousel>
    ) : (
      false
    );
  }

  renderHeadlines = () =>
    this.props.headlines.map((headline, index) => {
      return <Headline key={index} {...headline} />;
    });
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/headlines_slider/mobile_headlines_slider.jsx